import axios from 'axios';

// Ensure CORS is configured in backend/config/settings/local.py
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api';

const api = axios.create({
  baseURL: API_URL,
});

export interface TeamMember {
  id: number;
  name: string;
  role: string;
  bio: string;
  image: string | null;
  linkedin_url: string;
  order: number;
}

export interface JobOpening {
  id: number;
  title: string;
  department: string;
  type: string;
  type_display: string;
  description: string;
  requirements: string;
  posted_at: string;
  is_active: boolean;
}

export interface BlogPost {
  id: number;
  title: string;
  slug: string;
  content: string;
  summary: string;
  author: string;
  category: string;
  image: string | null;
  published_at: string;
  read_time: number;
}

export interface PaginatedResponse<T> {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

export const getTeamMembers = async () => {
  const response = await api.get<TeamMember[]>('/team/');
  return response.data;
};

export const getJobOpenings = async () => {
  const response = await api.get<JobOpening[]>('/jobs/');
  return response.data;
};

export const getBlogPosts = async (page = 1) => {
  const response = await api.get<PaginatedResponse<BlogPost>>(`/blog/?page=${page}`);
  return response.data;
};

export const getBlogPostBySlug = async (slug: string) => {
  const response = await api.get<BlogPost>(`/blog/${slug}/`);
  return response.data;
};


export const apiService = {
  get: <T>(url: string, config?: any) => api.get<T>(url, config).then(res => res.data),
  post: <T>(url: string, data?: any, config?: any) => api.post<T>(url, data, config).then(res => res.data),
  put: <T>(url: string, data?: any, config?: any) => api.put<T>(url, data, config).then(res => res.data),
  patch: <T>(url: string, data?: any, config?: any) => api.patch<T>(url, data, config).then(res => res.data),
  delete: <T>(url: string, config?: any) => api.delete<T>(url, config).then(res => res.data),
};

export default api;